
const m = window.require("discourse/helpers/component-for-row");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
